// extracted by mini-css-extract-plugin
module.exports =  {"bsmi":"bsmi__Gb2P5"};